// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"175":"c49159f0","193":"da32a9aa","213":"0b0fe0fe","450":"49550b5c","557":"c565d085","667":"c61fa669"}[chunkId] + ".chunk.js";
};